
module.exports = function (md) {
  md.core.ruler.push('append_header_attrs', function appendHeaderAttrs(state) {
    let previousHeadingOpenIndex = null;

    for (let i = 0; i < state.tokens.length; i++) {
      const token = state.tokens[i];
      if (previousHeadingOpenIndex !== null) {
        const headingOpen = state.tokens[previousHeadingOpenIndex];
        headingOpen.attrs = [
                    ['data-section-id', token.content],
                    ['data-level', headingOpen.tag.substr(1)],
        ];
        if (token.map) {
          headingOpen.attrs.push(['data-md-block', `${Number(token.map[0]).toString(36)},${Number(token.map[1]).toString(36)}`]);
        }

        previousHeadingOpenIndex = null;
      }

      if (token.type === 'heading_open') {
        previousHeadingOpenIndex = i;
      }
    }
  });
};
